// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import { useConfiguration } from '../../context/configurationContext';
import { LinkedLogo, NamedLink } from '../../components';

import '../../styles/tailwind.css';

const FooterStyled = () => {
  const intl = useIntl();
  const config = useConfiguration();
  const { topbar } = config;
  const logoLink = topbar?.logoLink;

  const searchLabel = intl.formatMessage({ id: 'FooterStyled.search' });
  const scheduleLabel = intl.formatMessage({ id: 'FooterStyled.schedule' });
  const campScoutLabel = intl.formatMessage({ id: 'FooterStyled.campScout' });
  const becomeProviderLabel = intl.formatMessage({ id: 'FooterStyled.becomeProvider' });
  const dashboardLabel = intl.formatMessage({ id: 'FooterStyled.dashboard' });
  const sloganText = intl.formatMessage({ id: 'FooterStyled.defaultSlogan' });
  const currentYear = new Date().getFullYear();
  const copyrightText = intl.formatMessage({ id: 'FooterStyled.defaultCopyright' }, { year: currentYear });

  return (
    <footer className="bg-foreground text-white dark:bg-card dark:text-foreground">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 py-10 lg:py-16 text-base font-medium max-w-6xl mx-auto">
          <div className="flex items-center gap-6 text-sm">
            <NamedLink name="SearchPage" className="text-white hover:text-accent transition-colors duration-300 no-underline hover:no-underline dark:text-foreground">
              {searchLabel}
            </NamedLink>
            <NamedLink name="SchedulePage" className="text-white hover:text-accent transition-colors duration-300 no-underline hover:no-underline dark:text-foreground">
              {scheduleLabel}
            </NamedLink>
            <a href="/kamp-planner" className="text-white hover:text-accent transition-colors duration-300 no-underline hover:no-underline dark:text-foreground">
              {campScoutLabel}
            </a>
          </div>

          <div className="flex items-center">
            <div className="brightness-0 invert dark:brightness-100 dark:invert-0">
              <LinkedLogo layout="desktop" linkToExternalSite={logoLink} alt="ActivityFox" />
            </div>
          </div>

          <div className="flex items-center gap-6 text-sm">
            <a href="/vendor/register" className="text-white hover:text-accent transition-colors duration-300 no-underline hover:no-underline dark:text-foreground">
              {becomeProviderLabel}
            </a>
            <NamedLink name="DashboardBasePage" className="text-white hover:text-accent transition-colors duration-300 no-underline hover:no-underline dark:text-foreground">
              {dashboardLabel}
            </NamedLink>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 dark:border-border">
        <div className="container px-4 md:px-6 flex flex-col items-center gap-3 py-6 text-sm text-white/60 dark:text-muted-foreground">
          <div className="flex items-center gap-2">
            <NamedLink name="TermsOfServicePage" className="hover:text-white transition-colors no-underline hover:no-underline dark:hover:text-foreground">
              {intl.formatMessage({ id: 'FooterStyled.termsOfService' })}
            </NamedLink>
            <span aria-hidden="true">&middot;</span>
            <NamedLink name="PrivacyPolicyPage" className="hover:text-white transition-colors no-underline hover:no-underline dark:hover:text-foreground">
              {intl.formatMessage({ id: 'FooterStyled.privacyPolicy' })}
            </NamedLink>
          </div>
          <p>{sloganText} &middot; {copyrightText}</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterStyled;
